import { render, staticRenderFns } from "./openFolder.vue?vue&type=template&id=67e04546"
import script from "./openFolder.vue?vue&type=script&lang=js"
export * from "./openFolder.vue?vue&type=script&lang=js"
import style0 from "./openFolder.vue?vue&type=style&index=0&id=67e04546&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports